export default {
	methods: 
    {		
		nuevoModal(modal)
		{
		  this.updateGlobal({state: 'openModal/modal/value',    data: true });
		  this.updateGlobal({state: 'openModal/modal/title',    data: 'Nuevo Servicio'});
		  this.updateGlobal({state: 'openModal/modal/modal',    data: 'Nuevo'});
		  this.updateGlobal({state: 'indexData', data: false});
		},				
		async getFiltrar()
		{
			await this.getDataGet({ route: 'get_listservicios', data: 'usuarios'})
			// frontend await this.searchGetIdb({tabla:'servicios_nuevos',campo:'iniciolabores',value:'',principal:'info_afiliacion'})
		}
	},
}